import { actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  extractDataFromObject,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
} from '../../../../../actions/utilAction';
export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  create_post_data,
  showErrorMessage,
  showSuccessMessage,
  extractDataFromObject,
  API_URL,
  createSearchUrl,
};

export const GET_APPCONFIG = `${API_URL}/AppConfigurations/GetAppConfigurations`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const PATIENT_ENCOUNTERS = `${API_URL}/patient-encounter/GetPatientEncounter`;
export const PATIENT_ENCOUNTERS_DETAILS = `${API_URL}/patient-encounter/GetPatientEncounterDetails`;
export const SOAP_API = `${API_URL}/patient-encounter/GetPatientEncounterDetails`;
export const SAVE_SOAP_API = `${API_URL}/patient-encounter/SavePatientEncounterExtension`;
export const GET_ICD_API = `${API_URL}/master-i-c-d`;
export const GET_CPT_API = `${API_URL}/master-service-code`;
export const Claim_API = `${API_URL}/Claim/CreateClaim`;
export const GET_PATIENT = `${API_URL}/patient`;
export const GET_APPOINTMENT_DATA_API = `${API_URL}/api/PatientAppointments/GetAppointmentDetails`;
export const GET_PAYER_SERVICE_CODES_API = `${API_URL}/patients/GetPatientPayerServiceCodes`;
export const UPDATE_SERVICE_CODES_BLOCKED_UNIT_API = `${API_URL}/api/PatientAppointments/UpdateServiceCodeBlockedUnit`;
export const GET_TELEHEALTH_SESSION = `${API_URL}/api/Telehealth/GetTelehealthSession`;
export const POST_ENCOUNTER_SIGNS_API = `${API_URL}/patient-encounter/SaveEncounterSignature`;
export const SAVE_CLOCKIN_TIME_API = `${API_URL}/api/PatientAppointments/SaveClockInTimeIntoAppointment`;

export const soapActionTypes = {
  get_appConfig: createRequestActionTypes('GET_APPCONFIG'),
  get_masterdata: createRequestActionTypes('GET_SOAP_MASTERSDATA'),
  get_patientById: createRequestActionTypes('GET_PATIENTDATA_BYID'),
  get_appointment_by_id: createRequestActionTypes('GET_APPOINTMENT'),
  get_patient_encounters: createRequestActionTypes('GET_PATIENT_ENCOUNTERS'),
  get_patient_single_encounters: createRequestActionTypes('GET_PATIENT_SINGLE_ENCOUNTERS'),
  post_patient_soap: createRequestActionTypes('POST_SOAP'),
  get_patient_soap: createRequestActionTypes('GET_SOAP'),
  get_CPT_byName: createRequestActionTypes('GET_CPT_BYNAME'),
  get_ICD_byName: createRequestActionTypes('GET_ICD_BYNAME'),
  create_claim: createRequestActionTypes('CREATE_CLAIM_BYENCOUNTERID'),
  getPatientPayerServiceCodes: createRequestActionTypes('GET_PATIENT_PAYER_SERVICECODES'),
  updateServiceCodeBlockedUnits: createRequestActionTypes('UPDATE_SERVICECODE_BLOCKED_UNITS'),
  get_telehealth_session: createRequestActionTypes('GET_TELEHEALTH_SESSION'),
  post_EncounterSigns: createRequestActionTypes('POST_ENCOUNTERSIGNS'),
  get_TargetsAndProgramsData: createRequestActionTypes('GET_TARGETSANDPROGRAMSDATA'),
  get_BehaviorsReductionsData: createRequestActionTypes('GET_BEHAVIORREDUCTIONSDATA'),
  post_clockin_time: createRequestActionTypes('POST_CLOCKIN_TIME_API'),
};




// WEBPACK FOOTER //
// ./src/modules/scheduling/components/SessionNotes_SOAR/constants/ApiConstants.js